import React from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle
} from '@/components/ui/dialog';
import {
  Loader2, Download, X, FileText, FileImage, File,
} from 'lucide-react';

// Full-screen document preview modal (PDF + images). Shared between the
// load-edit hover preview and explicit "Open in full preview" flow.
export const FullPreviewModal = ({ open, onOpenChange, previewDoc, previewUrl, previewLoading, onDownload }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-slate-900 border-slate-800 max-w-4xl h-[85vh] flex flex-col p-0">
      <DialogHeader className="px-6 py-4 border-b border-slate-800 flex-shrink-0">
        <div className="flex items-center justify-between">
          <DialogTitle className="text-white flex items-center gap-2">
            {previewDoc?.content_type?.startsWith('image/')
              ? <FileImage className="h-5 w-5 text-blue-400" />
              : <File className="h-5 w-5 text-red-400" />}
            <span className="truncate max-w-md">{previewDoc?.filename}</span>
          </DialogTitle>
          <div className="flex items-center gap-2">
            <Button variant="outline" size="sm" className="border-slate-700" onClick={() => previewDoc && onDownload(previewDoc)}>
              <Download className="h-4 w-4 mr-2" />Download
            </Button>
            <Button variant="ghost" size="icon" className="h-8 w-8 text-slate-400 hover:text-white" onClick={() => onOpenChange(false)}>
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </DialogHeader>
      <div className="flex-1 overflow-hidden bg-slate-950">
        {previewLoading ? (
          <div className="flex items-center justify-center h-full"><Loader2 className="h-8 w-8 animate-spin text-blue-500" /></div>
        ) : previewUrl ? (
          previewDoc?.content_type?.startsWith('image/') || previewDoc?.filename?.toLowerCase().match(/\.(png|jpg|jpeg|gif|webp)$/) ? (
            <div className="flex items-center justify-center h-full p-4">
              <img src={previewUrl} alt={previewDoc?.filename} className="max-w-full max-h-full object-contain" />
            </div>
          ) : (
            <div className="flex flex-col h-full">
              <object data={previewUrl} type="application/pdf" className="flex-1 w-full" style={{ background: 'white', minHeight: '400px' }}>
                <div className="flex flex-col items-center justify-center h-full text-slate-500 bg-white p-8">
                  <FileText className="h-16 w-16 mb-4 text-red-400" />
                  <p className="text-slate-700">PDF preview not supported in this browser</p>
                  <Button onClick={() => previewDoc && onDownload(previewDoc)} className="mt-4 bg-blue-600 hover:bg-blue-500">
                    <Download className="h-4 w-4 mr-2" />Download to View
                  </Button>
                </div>
              </object>
              <div className="bg-slate-800 border-t border-slate-700 p-4 flex items-center justify-between">
                <div className="flex items-center gap-3 text-slate-300">
                  <FileText className="h-5 w-5 text-red-400" />
                  <span className="text-sm">If the preview does not load, click Download to view the file</span>
                </div>
                <Button onClick={() => previewDoc && onDownload(previewDoc)} className="bg-blue-600 hover:bg-blue-500">
                  <Download className="h-4 w-4 mr-2" />Download PDF
                </Button>
              </div>
            </div>
          )
        ) : (
          <div className="flex flex-col items-center justify-center h-full text-slate-500">
            <FileText className="h-16 w-16 mb-4" /><p>Unable to preview document</p>
          </div>
        )}
      </div>
    </DialogContent>
  </Dialog>
);
